export const ScreenConstants = {
  relatedRequests: "MAILBOXQUERY",
  placa: {
    mailBoxPlaca: "MAILBOXPLACA",
    queryPlaca: "QUERYPLACA",
    queryPlacaHistory: "QUERYPLACAHISTORY",
    filesPlaca: "FILESPLACA",
  },
  certificates: {
    mailBoxCertificates: "MAILBOXCERTIFICATES",
    queryCertificates: "QUERYCERTIFICATES",
    queryCertificatesHistory: "QUERYCERTIFICATESHISTORY",
  },
  coc: {
    mailBoxCoc: "MAILBOXCOC",
    queryCoc: "QUERYCOC",
    queryCocHistory: "QUERYCOCHISTORY",
  },
  admDatos: {
    masterTables: "MASTERTABLES",
    datosCDT: "DATOSCDT",
    wltp: "WLTP",
  },
  admSistemas: {
    masterTables: "MASTERTABLES",
    usuarios: "USUARIOS",
    concesionarios: "CONCESIONARIOS",
    historicoBastidor: "HISTORICOBASTIDOR",
    templateRules: "TEMPLATERULES",
    templates: "TEMPLATES",
    ayudasGenerales: "AYUDASGENERALES",
    printFormats: "PRINTFORMATS",
    listPrintFormats: "LISTPRINTFORMATS",
    printRules: "LISTPRINTRULES",
    reforms: "REFORMS",
    availableFields: "AVAILABLEFIELDS",
    fsPlaca: "FSPLACA",
  },
};
